module.exports = __webpack_public_path__ + "static/media/baseline-calendar.789c10c0.svg";